import {type LngLat, type MapLocationRequest, type Margin} from '@yandex-delivery/blocks'
import {useUpdateEffect} from '@yandex-delivery/utils/hooks'

export function useMapZoomCenterUpdate(
  route: LngLat[] = [],
  onLocationRequest?: (location: MapLocationRequest) => void,
  customMargin?: Margin,
) {
  const center = route?.[0]

  useUpdateEffect(() => {
    if (route.length !== 1) {
      return
    }

    if (onLocationRequest === undefined) {
      return
    }

    onLocationRequest({center, zoom: 16, duration: 300})
  }, [center, customMargin, route.length, onLocationRequest])
}
